import _ from 'lodash';
import React, { Component } from 'react';
import TicketItem from './TicketItem';

export default class TicketItems extends Component {
  renderTickets(items) {
    return _.map(items, (item) => {
        const { pin } = item;

        return (
          <TicketItem
            key={pin}
            item={item}
          />
        );
    });
  }

  render() {
    const {
      groupNm,
      items,
    } = this.props;

    return (
      <div className="box-item">
        <h3 className="item-title">{groupNm}</h3>
        {this.renderTickets(items)}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/TicketItems.jsx